import setupWebViewJavascriptBridge from './navigation'

// 获取环境信息
export const getEnv = () => {
  const data = {
    project: '',
    os: '',
    version: '',
    wx: '',
  }

  //  *** Mobile/15E148 PROJECT/SDZH OS/IOS VERSION/0.9.3
  const env = navigator.userAgent
  // console.log('env---->', env)

  const reg1 = /\sPROJECT\/([A-Z_]+)\s/
  const r1 = env.match(reg1)

  if (r1 != null) {
    data.project = r1[1]
  }

  const reg2 = /\sOS\/([A-Z]+)\s/
  const r2 = env.match(reg2)
  if (r2 != null) {
    data.os = r2[1]
  }

  const reg3 = /\sVERSION\/([0-9]+\.[0.9]+\.[0-9]+)/
  const r3 = env.match(reg3)
  if (r3 != null) {
    data.version = r3[1]
  }

  // console.log('设置环境信息---->', data)
  return data
}

// 判断是否在微信内
export const isWeixin = () => {
  const UA = navigator.userAgent.toLowerCase()
  return UA.indexOf('micromessenger') !== -1
}

// 判断是否在APP内
let isAppFlag = undefined
export const isApp = () => {
  if (isAppFlag !== undefined) {
    return isAppFlag
  }

  const env = getEnv()
  isAppFlag = !!env.project
  return isAppFlag
}

// 获取用户token
export const getToken = () => {
  return new Promise((resolve) => {
    if (isApp()) {
      setupWebViewJavascriptBridge((bridge) => {
        bridge.callHandler('getToken', {}, function (responseData) {
          console.log('responseData---->', responseData)
          resolve(JSON.parse(responseData))
        })
      })
    } else {
      console.log('请在APP内打开')
    }
  })
}



// 调起登录
export const login = () => {
  return new Promise((resolve) => {
    if (isApp()) {
      window.WebViewJavascriptBridge.callHandler(
        'login',
        {},
        (responseData) => {
          console.log('login: responseData---->', responseData)
          resolve(JSON.parse(responseData))
        }
      )
    } else {
      resolve({
        code: 200,
        data: {},
        msg: '获取失败'
      })
    }
  })
}

// 关闭webview
export const close = () => {
  if (isApp()) {
    window.WebViewJavascriptBridge.callHandler('close', {}, function (responseData) {
      console.log('responseData---->', responseData)
    })
  }
}

// 返回上一页
export const goback = () => {
  if (isApp()) {
    window.WebViewJavascriptBridge.callHandler('goback', {}, function (responseData) {
      console.log('responseData---->', responseData)
    })
  } else {
    history.go(-1)
  }
}


// 设置导航栏
export const setNavigationBar = (data) => {
  if (isApp()) {
    setupWebViewJavascriptBridge((bridge) => {
      bridge.callHandler('setNavigationBar', data, function (responseData) {
        console.log('responseData---->', responseData)
      })
    })
  }
}

// 获取状态栏高度
export const getStatusBarHeight = (data) => {
  return new Promise((resolve) => {
    if (isApp()) {
      setupWebViewJavascriptBridge((bridge) => {
        bridge.callHandler('getStatusBarHeight', data, function (responseData) {
          console.log('responseData---->', responseData)
          resolve(JSON.parse(responseData))
        })
      })
    } else {
      resolve({
        code: 200,
        data: 0,
        msg: ''
      })
    }
  })
}

export const nativeRoute = (data) => {
  console.log('nativeRoute: data---->', data)
  if (isApp()) {
    window.WebViewJavascriptBridge.callHandler('nativeRoute', data, function (responseData) {
      console.log('responseData---->', responseData)
    })
  } else {
    console.log('请在app内打开')
  }
}

// phoneCall（调起原生拨打电话）
export const phoneCall = (phone) => {
  return new Promise((resolve) => {
    setupWebViewJavascriptBridge((bridge) => {
      bridge.callHandler('phoneCall', { phone }, function (responseData) {
        console.log('phoneCall---->', responseData)
        resolve(JSON.parse(responseData))
      })
    })
  })
}

// chooseImage 选择图片
export const chooseImage = (phone) => {
  return new Promise((resolve) => {
    setupWebViewJavascriptBridge((bridge) => {
      bridge.callHandler('chooseImage', phone, function (responseData) {
        console.log('chooseImage---->', responseData)
        resolve(JSON.parse(responseData))
      })
    })
  })
}

// chooseImage 选择图片
export const webCallback = (webData) => {
  return new Promise((resolve) => {
    setupWebViewJavascriptBridge((bridge) => {
      bridge.callHandler('webCallback', webData, function (responseData) {
        console.log('webCallback---->', responseData)
        resolve(JSON.parse(responseData))
      })
    })
  })
}
